import React, { useEffect, useState } from 'react'
import { FiArrowLeftCircle } from 'react-icons/fi'
import { Categories } from '../catalogs/Categories'
import { Brands } from '../catalogs/Brands'
import { Suppliers } from '../catalogs/Suppliers'
import { useDispatch } from 'react-redux'
import { clearCatalogMemory } from '../../app/store/catalogs/thunk'

export const Catalogs = () => {

    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState("categories");
    const handleTabChange = (e) => {
        const target = e.target.getAttribute("data-bs-target");
        if (target === "#v-pills-home") setActiveTab("categories");
        if (target === "#v-pills-profile") setActiveTab("brands");
        if (target === "#v-pills-messages") setActiveTab("suppliers");
    };

    useEffect(() => {
        const tabs = document.querySelectorAll('[data-bs-toggle="pill"]');
        tabs.forEach(tab => {
            tab.addEventListener("shown.bs.tab", handleTabChange);
        });
        return () => {
            tabs.forEach(tab => {
                tab.removeEventListener("shown.bs.tab", handleTabChange);
            });
        };
    }, []);


    const clearMemory = () => {
        dispatch(clearCatalogMemory())
    }

    return (
        <div className='row'>
            <div className='col-12'>
                <h1 className="h3 mb-3 fw-bold">
                    Catalogos
                </h1>
            </div>

            <div className='col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2' >
                <div className=''>
                    <div className="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <button onClick={clearMemory} className="nav-link active" id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home" aria-selected="true">Categorias</button>
                        <button onClick={clearMemory} className="nav-link" id="v-pills-profile-tab" data-bs-toggle="pill" data-bs-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false">Marcas</button>
                        <button onClick={clearMemory} className="nav-link" id="v-pills-messages-tab" data-bs-toggle="pill" data-bs-target="#v-pills-messages" type="button" role="tab" aria-controls="v-pills-messages" aria-selected="false">Proveedores</button>
                    </div>
                </div>
            </div>

            <div className='col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 col-xxl-10'>
                <div className="tab-content " id="v-pills-tabContent">
                    <div className="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab" >
                        <Categories activeTab={activeTab} />
                    </div>
                    <div className="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab" >

                        <Brands activeTab={activeTab} />
                    </div>
                    <div className="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab" >
                        <Suppliers activeTab={activeTab} />
                    </div>
                </div>
            </div>
        </div>
    )
}
